<template>
  <div>
    <el-scrollbar style="height:100%;">
      <el-menu :default-active="onRoutes"
               :collapse="collapse"
               class="el-menu-vertical-demo"  :class="{'english' : language === 'english'}"
               :collapse-transition="false" unique-opened router @select="handleSelect">
        <template v-for="item in menuList">
          <el-menu-item :index="item.url" :key="item.url" :disabled="item.disable"
            v-if="currentSide === 'management' ? uesrAuth.includes(item.auth) : uesrAuth.includes(item.auth) && controlAuth.includes(item.auth)">
            <span slot="title">{{ $t(item.name) }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
    currentSide:{
      type: String
    }
  },
  name: "secondMenu",
  data() {
    return {
      collapse: false
    }
  },
  computed: {
    onRoutes() {
      return this.$route.path;
    },
    controlAuth(){
      return this.$store.state.controlAuth
    },
    uesrAuth(){
      return this.$store.state.userInfo.authorities
    },
    language() {
      return this.$store.state.language
    }
  },
  methods: {
    handleSelect(selectName) {
      if (selectName.indexOf('monitor') >= 0) {
        localStorage.setItem('monitor', selectName)
      } else if (selectName.indexOf('query') >= 0) {
        localStorage.setItem('query', selectName)
      } else if (selectName.indexOf('test') >= 0) {
        localStorage.setItem('test', selectName)
      } else if (selectName.indexOf('setting') >= 0) {
        localStorage.setItem('setting', selectName)
      } else if (selectName.indexOf('install') >= 0) {
        localStorage.setItem('install', selectName)
      } else if (selectName.indexOf('system') >= 0) {
        localStorage.setItem('system', selectName)
      } else if (selectName.indexOf('management') >= 0) {
        localStorage.setItem('management', selectName)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu {
  border-right: none;
  .el-menu-item *{
    vertical-align: top;
  }
  .el-menu-item.is-active{
    color: #00BEFF !important;
  }
  &.english{
    .el-menu-item{
      width: 184px !important;
      display: inline-block !important;
      word-wrap:break-word !important;
      line-height: 28px !important;
      white-space: pre-wrap;
      & > span{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  /*.is-active {
    border-left: 4px solid #409EFF !important;
  }*/
}
</style>
